var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 34H8.68537C8.37048 34 8.16567 33.6686 8.3065 33.387L8.73263 32.5347C9.57182 30.8563 10.1293 29.0514 10.3829 27.1921L11.4813 19.1373C12.3513 12.7568 17.8009 8 24.2404 8C25.1861 8 26.1096 8.1024 27 8.29711M28 38.5V39C28 41.2091 26.2091 43 24 43C21.7908 43 20 41.2091 20 39V38.5C20 36.0147 22.0147 34 24.5 34H39.3871C39.6687 34 39.8518 33.7037 39.7259 33.4518L39.3582 32.7164C38.4606 30.9213 37.9067 28.9742 37.725 26.9755L37.3948 23.3434",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9408 7.29009C32.9539 7.22557 33.0461 7.22557 33.0593 7.29009C33.7438 10.6391 36.361 13.2562 39.71 13.9408C39.7745 13.9539 39.7745 14.0461 39.71 14.0593C36.361 14.7438 33.7438 17.361 33.0593 20.71C33.0461 20.7745 32.9539 20.7745 32.9408 20.71C32.2562 17.361 29.6391 14.7438 26.2901 14.0593C26.2256 14.0461 26.2256 13.9539 26.2901 13.9408C29.6391 13.2562 32.2562 10.6391 32.9408 7.29009Z",
    stroke: "#5200FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4374 2.75215C41.5626 2.13991 42.4374 2.13991 42.5625 2.75215C42.8389 4.10434 43.8956 5.16106 45.2478 5.43744C45.86 5.56258 45.86 6.43735 45.2478 6.56249C43.8956 6.83887 42.8389 7.89559 42.5625 9.24778C42.4374 9.86002 41.5626 9.86002 41.4374 9.24778C41.1611 7.89559 40.1043 6.83887 38.7521 6.56249C38.1399 6.43735 38.1399 5.56258 38.7521 5.43744C40.1043 5.16106 41.1611 4.10434 41.4374 2.75215Z",
    fill: "#5200FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5V8",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.92745c9fff4a058bd96777dc07f6034f.svg";
export { ForwardRef as ReactComponent };